var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[    'CEESAR-ControlBox',
                  _vm.required? 'CEESAR-ControlBox-Required': '', 
                  _vm.horizontal? 'CEESAR-ControlBox-Horizontal': '']},[_c('label',{staticClass:"CEESAR-ControlBoxLabel CEESAR-AlignLabel"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }